import { ApiStudentTimesheetStatus } from "src/api/types";
import Badge from "src/components/Badge";
import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";

const styles: any = {
	unknown: {
		bg: "gray",
		color: "dark",
	},
	pending: {
		bg: "gray",
		color: "dark",
	},
	disapproved: {
		bg: "red-300",
		color: "red",
	},
	canceled: {
		bg: "red-300",
		color: "red",
	},
	approved: {
		bg: "green-300",
		color: "green",
	},
	processed: {
		bg: "dark",
		color: "white",
	},
};

interface TimesheetStatusProps extends Translation {
	status: ApiStudentTimesheetStatus;
}

const TimesheetStatus = ({ t, status }: TimesheetStatusProps) => {
	return <Badge {...styles[status]}>{t(status)}</Badge>;
};

TimesheetStatus.locale = {
	nl: {
		unknown: "Nog niet ingevuld",
		pending: "In afwachting",
		disapproved: "Afgekeurd",
		approved: "Goedgekeurd",
		processed: "Verwerkt",
		canceled: "Geannuleerd",
	},
	en: {
		unknown: "Not submitted",
		pending: "Pending",
		disapproved: "Denied",
		approved: "Approved",
		processed: "Processed",
		canceled: "Canceled",
	},
};

export default withTranslation(TimesheetStatus);
